import React from 'react';
import About from '../components/About/About';
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs';

const AboutPage = () => {
  return (
    <div style={{ marginTop: '151px' }}>
      <About />
      <WhyChooseUs />
    </div>
  );
};

export default AboutPage;
